import { useQuery } from "@tanstack/react-query";
import { getSale } from "@/lib/api";

export const useSale = () => {
  const { data } = useQuery({ queryKey: ["sale"], queryFn: getSale, staleTime: 60 * 1000 });
  return data;
};

export const applySale = (price, sale) => {
  if (!sale?.is_running || !sale.discount_percentage) {
    return { final: price, original: null, pct: 0 };
  }
  return {
    final: Math.round(price * (1 - sale.discount_percentage / 100)),
    original: price,
    pct: sale.discount_percentage,
  };
};
